import { createFileRoute } from "@tanstack/react-router";

import { TemplatesSection } from "../components/regulation/templates/TemplatesSection";
import { templatesSearch } from "../components/regulation/templates/templatesView";

function LibraryTemplatesRoute() {
  const search = Route.useSearch();
  return <TemplatesSection forDocument={search.for ?? null} />;
}

export const Route = createFileRoute("/$org/compliance/templates")({
  validateSearch: templatesSearch,
  component: LibraryTemplatesRoute,
});
